import Vue from 'vue';
import api from '../api';
import BundleApp from '../bundle-app.vue';
/**
 * 번들 구성, 번들+현물 구성
 *
 */
const fetchData = async (tgLayout) => {
  const pageId = document.getElementById('main').dataset.pageId;
  const props = {
    ...tgLayout.getElementsByClassName('fc-layout-data')[0].dataset,
    pageId,
  };
  try {
    const {
      data: { data: bundleData },
    } = await api.getProductById(props.productId);

    const productList = bundleData.products;
    const { listPrice, salePrice, discountAmount } = bundleData;
    const prices = { listPrice, salePrice, discountAmount };

    new Vue({
      render: (h) =>
        h(BundleApp, { props: { ...props, bundleData, prices, productList, isPurchasable: bundleData.isPurchasable } }),
    }).$mount(tgLayout.getElementsByClassName('container-fluid')[0]);
  } catch (err) {
    console.log(err);
  }
};

const initLayout = async (layoutType) => {
  const layoutList = document.getElementsByClassName(layoutType);
  [...layoutList].forEach((layout) => {
    fetchData(layout);
  });
};

export { initLayout };
